import { FuelIcon, FuelTypography } from '@frete.com/fuel-react';
import { FuelFlex } from '@frete.com/fuel-station-react';
import { FormModalUpsell } from 'components/Externals/FormModalUpsell';
import useHandlePlanUpgrade from 'hooks/useHandlePlanUpgrade';
import React, { FC, useState } from 'react';
import * as Styled from './styled';

export const BannerLockedDrivers: FC = () => {
  const { handlePlanUpgradeClick, handleFormModalUpsellEvents } = useHandlePlanUpgrade();

  const [isOpenFormModal, setIsOpenFormModal] = useState(false);

  const handleToggleModal = () => setIsOpenFormModal((prev) => !prev);

  const handleFormModal = () => {
    handleFormModalUpsellEvents('learn-more-ask-for-contact');
    handleToggleModal();
  };

  const handleClick = () => {
    handlePlanUpgradeClick('saiba-mais', () => setIsOpenFormModal(true));
  };

  return (
    <>
      <FuelFlex
        testId="banner-locked-drivers"
        defaultProps={{
          alignItems: 'center',
          justifyContent: 'center',
          gap: 'km4',
          padding: 'km4',
        }}
      >
        <FuelIcon name="lock" iconStyle="filled" />
        <FuelTypography size="body-md" weight="medium">
          O plano atual não permite a exibição de todos os motoristas para esse frete.{' '}
          <Styled.UnderlinedText onClick={handleClick}>Saiba mais</Styled.UnderlinedText>
        </FuelTypography>
      </FuelFlex>

      <FormModalUpsell
        isOpen={isOpenFormModal}
        onClose={() => setIsOpenFormModal(false)}
        handleFormModal={handleFormModal}
        toggleFormModal={() => setIsOpenFormModal((prev) => !prev)}
        feature="listamotoristassugeridos"
      />
    </>
  );
};
